import React from "react";

const Content = ({ children }) => (
  <div className="content d-flex flex-column flex-grow-1">{children}</div>
);

export default Content;
